import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import styled from 'styled-components';
import utils from 'helpers/utils';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchAccountAccumulated } from 'store/actions/accounts/fetchAccounts';
import theme from 'theme/theme';

const TextFieldWrapper = styled.div`
    margin: 0 0 20px 0;
`;

const Title = styled(Link)`
    font-size: 15px;
    font-weight: bold;
    line-height: 1.6;
    text-decoration: underline;
    color: ${ theme.palette.black }
`;

const Text = styled.div`
    font-size: 14px;
    line-height: 1.4;
`;

class AccountShowField extends React.Component {
    componentDidMount() {
        const { data } = this.props;

        if (utils.isEmpty(data)) {
            this.fetchData();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.fetchData();
        }
    }

    fetchData() {
        const { dispatchAction, value } = this.props;

        /**
         * This will trigger a specific action, which is defined in the upper level.
         * This action can only be a function, and will always pass the id of the record.
         */
        dispatchAction(fetchAccountAccumulated({
            id: value,
        }));
    }

    render() {
        const { data } = this.props;

        if (utils.isEmpty(data)) {
            return null;
        }

        return (
            <TextFieldWrapper>
                <Title to={ `/accounts/${ data.id }/show` }>{ data.name }</Title>

                { !utils.isEmpty(data.email) &&
                    <Text>E: { data.email }</Text>
                }

                { !utils.isEmpty(data.phone) &&
                    <Text>P: { data.phone }</Text>
                }
            </TextFieldWrapper>
        );
    }
}

AccountShowField.propTypes = {
    data: PropTypes.object,
    dispatchAction: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

const mapStateToProps = (state, props) => {
    const { value } = props;

    const stateResource = state.accounts;

    return {
        data: stateResource.data[value],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchAction: (action) => {
            dispatch(action);
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
);

export default enhance(AccountShowField);



// WEBPACK FOOTER //
// ./src/components/show/AccountShowField.js